export default __webpack_public_path__ + "static/media/PetTraitIcon.39eb3776.svg";